// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeSubCategory_wrapper__14PY0","footer":"ChangeSubCategory_footer__SBcVd"};